import { __rest } from "tslib";
import styled from 'styled-components';
import React from 'react';
import { Spinner } from '@@Components/Spinner';
import { filterKeys } from '@@Helpers/filterKeys';
const CommonButton = styled.button `
  font-size: 14px;
  font-style: italic;
  box-sizing: border-box;
  position: relative;
  max-width: ${props => props.maxWidth ? `${props.maxWidth}px` : 'auto'};
  ${props => props.margin && `margin: ${props.margin}`};
  width: 100%;
  transition: all 200ms linear;
  cursor: pointer;
  display: inline-block;
  line-height: 40px;
  height: 42px;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:focus {
    outline: none;
  }
  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0) !important;
    margin: 0;
  }
  ${props => props.theme.mixins.mobile(`
    height: 34px;
    line-height: 32px;
    font-size: 13px;
  `)}
`;
CommonButton.defaultProps = {};
const OutlineButton = styled(CommonButton) `
  width: 100%;
  background-color: ${(props) => props.theme.colors[props.color || 'white']};
  border: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.border};
  &:not([disabled]):hover {
    border: 1px solid ${props => props.theme.colors.primary};
  }
  &:not([disabled]):active {
    border: 1px solid ${props => props.theme.colors.primaryAccent};
  }
  &[disabled] {
    opacity: 0.3;
    cursor: default;
    top: 0 !important; /* To prevent pressing effect when :active */
  }
`;
const DarkButton = styled(OutlineButton) `
  background-color: ${(props) => props.theme.colors[props.color || 'black']};
  border: none;
  color: white;
  &:not([disabled]):hover {
    border: none;
    background-color: ${props => props.theme.colors.primary};
  }
  &:not([disabled]):active {
    border: 1px solid ${props => props.theme.colors.primaryAccent};
  }
`;
const TextButton = styled(CommonButton) `
  border: 1px solid transparent;
  background-color: none;
  height: auto;
  width: auto;
  font-style: normal;
  line-height: inherit;
  svg {
    fill: ${props => props.theme.colors.default};
  }
  &[disabled] {
    color: ${props => props.theme.colors.disabled};
    cursor: not-allowed;
  }
  padding-left: 0;
  padding-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    fill: currentColor;
  }
  &:not([disabled]):hover {
    background-color: none;
    text-decoration: underline;
    transition: all .3s ease;
    svg {
      fill: currentColor;
    }
  }
  ${props => props.theme.mixins.mobile('font-size: 14px;')}
`;
export const Button = (_a) => {
    var { appearance } = _a, customProps = __rest(_a, ["appearance"]);
    const children = customProps.loading ? React.createElement(Spinner, { color: "#121212" }) : customProps.children;
    /**
     * filter out the 'loading' property as it is non standard and it's being passed down to
     * <button> element, which causes React to throw an error.
     */
    const filteredProps = filterKeys(customProps, ['loading']);
    switch (appearance) {
        case 'outline':
            return React.createElement(OutlineButton, Object.assign({}, filteredProps), children);
        case 'text':
            return React.createElement(TextButton, Object.assign({}, filteredProps), children);
        case 'dark':
        case 'primary':
            return React.createElement(DarkButton, Object.assign({}, filteredProps), children);
        default:
            return React.createElement(OutlineButton, Object.assign({}, filteredProps), children);
    }
};
export default Button;
